import React, {useEffect, useState} from 'react';
import {useNavigate} from "react-router-dom";
import {Button, Card, Col, Form, Image, Input, message, Row} from "antd";
import {LockOutlined, UserOutlined, LoginOutlined, UnlockOutlined} from "@ant-design/icons";
import {useDispatch, useSelector} from "react-redux";
import Logo from "../../../assets/octoopi_logo.png";
import {useLoginMutation} from "../../../slices/rootApiSlices/authApiSlice";
import {setCredentials} from "../../../slices/authSlice";

const Index = () => {

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [authenticate, {isLoading}] = useLoginMutation();

    const {user} = useSelector((state) => state.auth);

    useEffect(() => {
        if (user) {
            navigate('/')
        }
    }, [navigate, user])

    const onFinish = async () => {
        try {
            const res = await authenticate({email, password}).unwrap();
            dispatch(setCredentials({...res}));
            navigate('/')
        } catch (err) {
            message.error(err?.data?.messageTR || 'Lütfen bir süre sonra tekrar deneyiniz.', 5)
        }
    }

    return (
        <Row gutter={16}>
            <Col>
                <Card style={{width: 380, height: 420}}>
                    <div style={{textAlign: "center"}}>
                        <Image src={Logo} preview={false} width="70px" height="70px"/>
                        <h2>Octoopi Twin Cocpit</h2>
                        <h3>Giriş Yap</h3>
                    </div>
                    <Form
                        name="normal_login"
                        className="login-form"
                        initialValues={{
                            remember: true,
                        }}
                        onFinish={onFinish}
                    >
                        <Form.Item
                            name="username"
                            rules={[
                                {
                                    type: "email",
                                    required: true,
                                    message: 'lütfen düzgün bir e-posta adresi giriniz !',
                                },
                            ]}
                        >
                            <Input
                                size="large"
                                prefix={<UserOutlined className="site-form-item-icon"/>}
                                placeholder="E-posta"
                                autoComplete="email"
                                name="email"
                                value={email}
                                disabled={isLoading}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </Form.Item>
                        <Form.Item
                            name="password"
                            rules={[
                                {
                                    type: "password",
                                    required: true,
                                    message: 'Şifre alanı boş bırakılamaz',
                                },
                            ]}
                        >
                            <Input
                                prefix={<LockOutlined className="site-form-item-icon"/>}
                                type="password"
                                autoComplete="current-password"
                                size="large"
                                name="password"
                                placeholder="Şifre"
                                disabled={isLoading}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </Form.Item>
                        <Form.Item>
                            <Button
                                size="large"
                                style={{marginBottom: 1, fontSize: 15, fontWeight: 500}}
                                type="primary"
                                disabled={!email || !password}
                                htmlType="submit"
                                className="login-form-button"
                                block
                                loading={isLoading}
                                icon={<LoginOutlined/>}
                            >
                                Giriş Yap
                            </Button>
                        </Form.Item>
                        <Form.Item style={{display: 'flex', justifyContent: 'space-between', alignItems: "center"}}>
                            <div style={{display: 'flex', alignItems: 'center', justifyContent: "space-between"}}>
                                <a href="/auth/reset-password"
                                   style={{marginLeft: 24, fontSize: 16, fontWeight: 500, textDecoration: "underline"}}>
                                    <UnlockOutlined style={{marginRight: 5}}/>
                                    Şifremi Unuttum ?
                                </a>
                            </div>
                        </Form.Item>
                    </Form>
                </Card>
            </Col>
        </Row>
    );
};

export default Index;
